const createAction = name => `@@formInvalidName/${name}`;
export const INVALID_PROPERTY_NAME_ERROR = createAction('INVALID_PROPERTY_NAME_ERROR');
export const invalidPropertyName = (propertyName, objectTypeId) => {
  return {
    type: INVALID_PROPERTY_NAME_ERROR,
    propertyName,
    objectTypeId
  };
};